"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  GOOGLE_MAPS_KEY: process.env.REACT_APP_GOOGLE_MAPS_KEY || '',
  SUPPORTED_BROWSERS: {
    Chrome: 84,
    Safari: 11,
    Firefox: 82,
    Edge: 84,
    Opera: 69,
    IE: 11
  }
};
exports.default = _default;